@if (surchargeTypeList) {
  <p-select
    appendTo="body"
    (onChange)="onSurchargeTypeChange($event)"
    [options]="surchargeTypeList"
    [(ngModel)]="surchargeType"
    [placeholder]="surchargeType?.getName() || 'Please select surcharge type'"
    [filter]="true"
    [filterFields]="['title']"
    [disabled]="disabled()"
    [class]="required() && !surchargeType ? 'has-error' : ''"
    [panelStyleClass]="'large'"
  >
  </p-select>
}
